<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">
          Delete user
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p>
                Are you sure you want to delete {{ data.firstName }} {{ data.lastName }}?
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="onClose">
          Cancel
        </v-btn>
        <v-btn
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="onDeleteUser"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalDeleteUser",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  methods: {
    onDeleteUser() {
      this.loading = true;
      this.$store
          .dispatch("UsersStore/deleteUser", this.data)
          .then(() => {
            this.$emit("delete");
            this.onClose();
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onClose() {
      this.dialog = false;
    }
  }
};
</script>
